import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Score = props => {
  const { active, score, setActiveRating } = props;

  const classes = classNames({
    'score': true,
    'score--active': active,
  });

  return (
    <span className={classes} key={score} onClick={() => setActiveRating(score)}>
      {score}
    </span>
  );
};

Score.propTypes = {
  active: PropTypes.bool,
  score: PropTypes.number,
  setActiveRating: PropTypes.func,
};

export default memo(Score);
